module.exports = __webpack_public_path__ + "img/ditu1234.1a90a6b5.png";